Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    appLayoutBackgroundColorPrincipal: tokens.themePageDefault,
    appLayoutBackgroundColorHighlight: tokens.themePageHighlight,
    appLayoutBackgroundColorSubdued: tokens.themePageSubdued
  }
};